import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey } from '../internal.js'

const credentialTypes = [apiKey] as const

export type wtchCredType = (typeof credentialTypes)[number]
export const wtchDocumentTypes = [
  'signed-bol',
  'proof-of-delivery',
  'delivery-photo',
  'other',
] as const satisfies readonly DocumentType[]

export const wtch: CarrierDef<wtchCredType> = {
  name: 'Warp Technology',
  scac: 'wtch',
  credentialTypes,
  engineLayers: ['documents'],
  documentTypes: wtchDocumentTypes,
}
